import { HttpClient } from 'common/HttpClient'
import { Environment } from 'enviroment/AppSettings'
import { PostalCodeModel } from './HelpersServiceProps'


export class HelpersService {
   private readonly _client : HttpClient
   private readonly _postalCodesUrlPath = "postalCodes";
   constructor(){
      this._client = new HttpClient(Environment.apiUrl);
   }

   public async getLocationByPostalCode(postalCode: string) : Promise<PostalCodeModel[]> {
      const postalCodeServiceUrlParams = new URLSearchParams({ postalCode: postalCode.trim() })
      const postalCodeUrlWithParams = `${this._postalCodesUrlPath}?${postalCodeServiceUrlParams.toString()}`

      try {
         const result = await this._client.get<PostalCodeModel[]>(postalCodeUrlWithParams, true)
         return result.data
         
      }
      catch (err){
          return []
      }
  }
}